export default "__VITE_ASSET__DyXV4ygZ__"